import { z } from 'zod';
import { emailValidation } from '../helpers/zod';

export const resetPasswordSchema = () =>
  z.object({
    email: emailValidation(),
  });

export type ResetPasswordType = z.TypeOf<ReturnType<typeof resetPasswordSchema>>;
